import Box from "@mui/material/Box";
import CustomContainer from "../CustomContainer";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Typography from "@mui/material/Typography";

export default function NumberOfUsesCard({ totalOfUses, totalOfInteractions }) {
  return (
    <CustomContainer
      sx={{
        alignItems: "center",
        display: "flex",
        height: "200px",
        justifyContent: "space-around",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          width: "220px",
        }}
      >
        <Typography
          color="primary"
          component="p"
          sx={{ fontWeight: 600 }}
          variant="h3"
        >
          {totalOfInteractions || "-"}
        </Typography>
        <Typography sx={{ fontSize: "20px" }}>
          QUANTIDADE DE INTERAÇÕES
        </Typography>
      </Box>
      {totalOfUses && (
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            width: "220px",
          }}
        >
          <Typography
            color="primary"
            component="p"
            sx={{ fontWeight: 600 }}
            variant="h3"
          >
            {totalOfUses || "-"}
          </Typography>
          <Typography sx={{ fontSize: "20px" }}>
          QUANTIDADE DE VISUALIZAÇŌES
          </Typography>
        </Box>
      )}
    </CustomContainer>
  );
}
